import { defineMessages } from 'react-intl';

const conciergePlanMessages = defineMessages({
    conciergePlanRatingHeader: {
        id: 'concierge.planRating.text',
        defaultMessage: 'Do you find this plan helpful?',
        description: 'Header text for the plan rating section',
    },
    conciergePlanRatingPositiveDialogHeader: {
        id: 'concierge.planRating.positive.dialog.header',
        defaultMessage: 'Great! Let us know why you find the plan helpful.',
        description: 'Header text for the plan rating dialog',
    },
    conciergePlanRatingNegativeDialogHeader: {
        id: 'concierge.planRating.negative.dialog.header',
        defaultMessage: 'Sorry to hear that. Let us know how we can improve.',
        description: 'Header text for the plan rating dialog',
    },
    conciergePlanRatingDialogSelectPlaceholder: {
        id: 'concierge.planRating.dialog.select.placeholder',
        defaultMessage: 'Select Response',
        description: 'Placeholder text for the plan rating select input',
    },
    conciergePlanRatingDialogSelectError: {
        id: 'concierge.planRating.dialog.select.error',
        defaultMessage: 'Error: Selection is required',
        description: 'Error message for the plan rating select input',
    },
    conciergePlanRatingAnswerSubmitted: {
        id: 'concierge.planRating.answer.submitted',
        defaultMessage: 'Thank you for sharing!',
        description: 'Confirmation that the user’s answer has been submitted.',
    },
    conciergePlanRatingDialogPositiveOption1: {
        id: 'concierge.planRating.dialog.positive.option1',
        defaultMessage: 'The plan has content that I find helpful',
        description: 'Positive plan rating option 1',
    },
    conciergePlanRatingDialogPositiveOption2: {
        id: 'concierge.planRating.dialog.positive.option2',
        defaultMessage: 'The plan has the right amount of content',
        description: 'Positive plan rating option 2',
    },
    conciergePlanRatingDialogPositiveOption3: {
        id: 'concierge.planRating.dialog.positive.option3',
        defaultMessage: 'I like the content in the plan',
        description: 'Positive plan rating option 3',
    },
    conciergePlanRatingDialogPositiveOption4: {
        id: 'concierge.planRating.dialog.positive.option4',
        defaultMessage:
            'The plan is well-aligned with my goal or mental health needs',
        description: 'Positive plan rating option 4',
    },
    conciergePlanRatingDialogNegativeOption1: {
        id: 'concierge.planRating.dialog.negative.option1',
        defaultMessage: 'The plan is too basic for my needs',
        description: 'Negative plan rating option 1',
    },
    conciergePlanRatingDialogNegativeOption2: {
        id: 'concierge.planRating.dialog.negative.option2',
        defaultMessage: 'The plan has too much audio or video content',
        description: 'Negative plan rating option 2',
    },
    conciergePlanRatingDialogNegativeOption3: {
        id: 'concierge.planRating.dialog.negative.option3',
        defaultMessage:
            'The plan has audio or video programs that I didn’t like',
        description: 'Negative plan rating option 3',
    },
    conciergePlanRatingDialogNegativeOption4: {
        id: 'concierge.planRating.dialog.negative.option4',
        defaultMessage:
            'The plan does not align with my goal or mental health needs',
        description: 'Negative plan rating option 4',
    },
    conciergePlanRatingDialogOptionOther: {
        id: 'concierge.planRating.dialog.optionOther',
        defaultMessage: 'Another reason not listed above',
        description: 'Plan rating option for "other" reason',
    },
    conciergePlanRatingTextboxPlaceholder: {
        id: 'concierge.planRating.textbox.placeholder',
        defaultMessage: 'Tell Us In Your Own Words',
        description: 'Placeholder text for the plan rating reason textbox',
    },
    conciergePlanViewMoreButton: {
        id: 'concierge.plan.viewMore.button',
        defaultMessage: 'View More',
        description: 'Button text to view more plan recommendations',
    },
    conciergePlanViewLessButton: {
        id: 'concierge.plan.viewLess.button',
        defaultMessage: 'View Less',
        description: 'Button text to view less plan recommendations',
    },
    conciergePlanFeedbackRelatedToGoal: {
        id: 'concierge.plan.feedback.relatedToGoal',
        defaultMessage: 'Related To Your Goal',
        description:
            'Feedback option indicating content is related to user goal',
    },
    conciergePlanFeedbackNotRelatedToGoal: {
        id: 'concierge.plan.feedback.notRelatedToGoal',
        defaultMessage: 'Not Related To Your Goal',
        description:
            'Feedback option indicating content is not related to user goal',
    },
    conciergeUpdateGoalsDialogTitle: {
        id: 'concierge.updateGoals.dialog.title',
        defaultMessage: 'Update Your Goal',
        description: 'Title for the update goals dialog',
    },
    conciergeUpdateGoalsDialogMessage: {
        id: 'concierge.updateGoals.dialog.message',
        defaultMessage:
            'Looks like you’re ready for some new recommendations! Select another goal (or even the same one) for fresh, new content.',
        description: 'Message displayed in the update goals dialog',
    },
    conciergeUpdateGoalsDialogBtn: {
        id: 'concierge.updateGoals.dialog.btn',
        defaultMessage: 'Update Goal',
        description: 'Button text to update the user’s goal',
    },
});

export default conciergePlanMessages;
